import Joi from 'joi'
import errorsResolver from '../schemeUtils'

const LAST_NAME_LENGTH = 100
const FIRST_NAME_LENGTH = 100
const MIDDLE_NAME_LENGTH = 100
const POSITION_LENGTH = 100
const PERSONAL_NUMBER = 14

const userPersonalInfoProperties = {
  lastName: Joi.string()
    .max(LAST_NAME_LENGTH)
    .required()
    .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ\\- ]*$`))
    .error(errorsResolver({
      max: `Фамилия должна быть до ${LAST_NAME_LENGTH} символов`,
      required: `Фамилия обязательное поле`,
      pattern: `Фамилия содержит некорректные символы`
    })),
  firstName: Joi.string()
    .max(FIRST_NAME_LENGTH)
    .required()
    .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ\\- ]*$`))
    .error(errorsResolver({
      max: `Имя должно быть до ${LAST_NAME_LENGTH} символов`,
      required: `Имя обязательное поле`,
      pattern: `Имя содержит некорректные символы`
    })),
  middleName: Joi.string()
    .max(MIDDLE_NAME_LENGTH)
    .required()
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ\\- ]*$'))
    .error(errorsResolver({
      max: `Отчество должно быть до ${MIDDLE_NAME_LENGTH} символов`,
      required: `Отчество обязательное поле`,
      pattern: `Отчество содержит некорректные символы`
    })),
  gender: Joi.string().required().valid('Мужской', 'Женский')
    .error(errorsResolver({
      required: `Пол обязательное поле`,
      values: `Пол обязательное поле`
    })),
  position: Joi.string()
    .max(POSITION_LENGTH)
    .required()
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ.\\- ]*$'))
    .error(errorsResolver({
      max: `Должность должна быть до ${POSITION_LENGTH} символов`,
      required: `Должность обязательное поле`,
      pattern: `Должность содержит некорректные символы`
    })),
  emplPersonalNum: Joi.string()
    .required()
    .max(PERSONAL_NUMBER)
    .min(PERSONAL_NUMBER)
    .pattern(new RegExp(`^[0-9]{7}[A-Z][0-9]{3}[A-Z]{2}[0-9]$`))
    .error(errorsResolver({
      max: `Личный номер должен содержать строго ${PERSONAL_NUMBER} символов`,
      min: `Личный номер должен содержать строго ${PERSONAL_NUMBER} символов`,
      pattern: 'Личный номер должен содержать цифры и латинские буквы в формате nnnnnnnAnnnAAn',
      required: 'Личный номер обязательное поле'
    })),
  active: Joi.bool()
}

const userAttorney = {
  attorney: {
    attorneyNumber: Joi.string()
        .max(18)
        .required()
        .pattern(new RegExp('^[0-9]*$'))
        .error(errorsResolver({
            max: `Номер доверенности должен быть не более 18 символов`,
            required: `Номер доверенности обязательное поле`,
            pattern: `Номер доверенности содержит некорректные символы`
        })),
    attorneyDate: Joi.date()
        .iso()
        .required()
        .error(errorsResolver({
            required: `Дата обязательное поле`,
            dateFormat: `Некорректная дата`,
        })),
    attorneyEndDate: Joi.date()
        .allow('')
        .allow(null)
        .allow(Joi.ref('attorneyDate'))
        .iso()
        .optional().when(Joi.ref('attorneyDate'), {
            is: Joi.date().required(),
            then:  Joi.date().greater(Joi.ref('attorneyDate')),
        })
        .error(errorsResolver({
            dateFormat: `Некорректная дата`,
            dateGreater: `Срок действия не может заканчиваться ранее даты выдачи`,
        }))
  }
}

const rolesProperties = {
    goodsSpecialist: Joi.bool(),
    accountant: Joi.bool(),
    admin: Joi.bool(),
    director: Joi.bool(),
    marketer: Joi.bool(),
    branchDirector: Joi.bool(),
    loyalGoodsSpecialist: Joi.bool()
}

const userScheme = Joi.object({
    user: Joi.object({
        ...userPersonalInfoProperties,
        ...userAttorney
    }).optional().when('roles.goodsSpecialist', {
        is: false,
        then: Joi.object({
            ...userPersonalInfoProperties,
            ...userAttorney
        })
    }),
    roles: Joi.object({
        ...rolesProperties
    }).when(Joi.object({
        goodsSpecialist: Joi.bool().valid(false),
        accountant: Joi.bool().valid(false),
        admin: Joi.bool().valid(false),
        director: Joi.bool().valid(false),
        marketer: Joi.bool().valid(false),
        branchDirector: Joi.bool().valid(false),
        loyalGoodsSpecialist: Joi.bool().valid(true),

    }).unknown(), {
        then: Joi.object({
            goodsSpecialist: Joi.bool().valid(false),
            accountant: Joi.bool().valid(false),
            admin: Joi.bool().valid(false),
            director: Joi.bool().valid(false),
            marketer: Joi.bool().valid(false),
            branchDirector: Joi.bool().valid(false),
            loyalGoodsSpecialist: Joi.bool().valid(false)
              .error(errorsResolver({
                values: `Должна быть выбрана основная роль`
            }))
        }),
        otherwise: Joi.object({
          ...rolesProperties
        }).when(Joi.object({
          goodsSpecialist: Joi.bool().valid( false),
            accountant: Joi.bool().valid( false),
            admin: Joi.bool().valid(false),
            director: Joi.bool().valid( false),
            marketer: Joi.bool().valid( false),
            branchDirector: Joi.bool().valid(false),
            loyalGoodsSpecialist: Joi.bool().valid(false)
        }).unknown(), {
            then: Joi.object({
              goodsSpecialist: Joi.bool().valid(true, false),
              accountant: Joi.bool().valid(true, false),
              admin: Joi.bool().valid(true, false),
              director: Joi.bool().valid(true, false),
              marketer: Joi.bool().valid(true, false),
              branchDirector: Joi.bool().valid(true, false),
              loyalGoodsSpecialist: Joi.bool().valid(true).error(errorsResolver({
                values: 'Выберите роль'
              }))
            }),
          otherwise: Joi.object({
            goodsSpecialist: Joi.bool().valid(true, false),
            accountant: Joi.bool().valid(true, false),
            admin: Joi.bool().valid(true, false),
            director: Joi.bool().valid(true, false),
            marketer: Joi.bool().valid(true, false),
            branchDirector: Joi.bool().valid(true, false),
            loyalGoodsSpecialist: Joi.bool().valid(true, false)
          })
        })
    })
})

export default userScheme

export const userEditScheme = Joi.object({
  user: Joi.object({
    ...userPersonalInfoProperties
  })
})

export const userAttorneyScheme = Joi.object({
  user: Joi.object({
    ...userAttorney
  })
})
